var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDdnMiniLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_121536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9365 0.000247849C16.3052 -0.00386135 13.7263 0.735702 11.4971 2.13371C14.9306 2.65415 18.4163 3.27753 21.7977 3.79868C22.578 3.95476 22.8382 4.11085 22.8382 4.4752C22.8382 7.33689 22.8901 10.2508 22.8382 13.1125C22.6821 16.5985 22.9943 20.1898 22.8382 23.6749C22.8382 24.1954 22.214 24.5075 21.3295 24.6114C18.1562 25.1319 14.9306 25.6001 11.7572 26.0684C13.9249 27.3261 16.3788 28.007 18.8845 28.0462C22.6093 28.0441 26.181 26.5633 28.8147 23.929C31.4485 21.2946 32.9289 17.7224 32.9308 13.997C32.9434 12.1554 32.5901 10.3297 31.8913 8.62586C31.1924 6.92202 30.1621 5.37402 28.8601 4.07179C27.5581 2.76955 26.0103 1.73903 24.3068 1.04008C22.6032 0.341125 20.7778 -0.0123276 18.9365 0.000247849Z",
    fill: "url(#paint0_linear_391_121536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1851 22.218C20.237 19.2521 20.1332 16.2344 20.1851 13.2685C20.237 10.8232 20.1851 8.32558 20.1851 5.87995C20.1905 5.73005 20.1404 5.58344 20.0443 5.46823C19.9483 5.35301 19.8131 5.2773 19.6647 5.25562C17.0634 4.63128 14.566 3.95476 12.0166 3.38238C11.237 3.17435 10.4053 3.01802 9.67621 2.86194H9.20803V2.80999C8.94279 2.7882 8.68095 2.73582 8.42773 2.65391V25.2877C8.74552 25.3285 9.05893 25.3981 9.36409 25.4957C9.52234 25.5044 9.68093 25.4868 9.83346 25.4438C10.9771 25.1316 12.0185 24.8194 13.1629 24.6112C15.1919 24.0907 17.3248 23.6225 19.4053 23.1023C19.873 22.9464 20.1851 22.6862 20.1851 22.218ZM18.7284 14.5687C18.5913 14.5852 18.4523 14.5738 18.3198 14.5352C18.1872 14.4966 18.0638 14.4316 17.957 14.3442C17.8502 14.2567 17.7622 14.1486 17.6982 14.0262C17.6342 13.9038 17.5956 13.7698 17.5847 13.6322C17.6245 13.3617 17.7638 13.1158 17.9753 12.9426C18.1869 12.7694 18.4554 12.6813 18.7284 12.6957C18.8654 12.6792 19.0044 12.6906 19.137 12.7292C19.2695 12.7678 19.3929 12.8327 19.4997 12.9202C19.6066 13.0077 19.6946 13.1158 19.7586 13.2382C19.8225 13.3605 19.8611 13.4945 19.872 13.6322C19.8729 13.7794 19.8285 13.9233 19.7447 14.0443C19.6609 14.1654 19.5419 14.2577 19.4038 14.3087V14.4648C19.3306 14.4726 19.2569 14.4542 19.1958 14.4128C19.0627 14.5178 18.8971 14.573 18.7277 14.5689L18.7284 14.5687Z",
    fill: "url(#paint1_linear_391_121536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8732 32C30.8488 32 39.7464 31.2079 39.7464 30.2309C39.7464 29.2538 30.8488 28.4618 19.8732 28.4618C8.89752 28.4618 0 29.2538 0 30.2309C0 31.2079 8.89752 32 19.8732 32Z",
    fill: "url(#paint2_radial_391_121536)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_391_121536",
    x1: 11.4971,
    y1: 14.0231,
    x2: 33.0169,
    y2: 14.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_391_121536",
    x1: 20.2317,
    y1: 14.0759,
    x2: 8.40417,
    y2: 14.0759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_391_121536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.87736 30.1778) scale(19.9086 19.9131)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_121536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32.0001,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdnMiniLogo);
export default __webpack_public_path__ + "static/media/ddn-mini-logo.14377b75311fea58712b71a389011b7e.svg";
export { ForwardRef as ReactComponent };